export default __webpack_public_path__ + "static/media/landing_page3.a45bbc2c.svg";